module.exports = Promise.all([__parcel__import__("ghDyT"), __parcel__import__("fpV0b")]).then(() => parcelRequire('4MH6n'));